import { CalendarDays, Users } from 'lucide-react';
import { GoDecision } from '@clawhire/shared';
import { formatDate } from '@/lib/format';
import { EnumBadge } from '@/components/data/EnumBadge';
import type { PositionListItem } from '../types';
import { FlagBadges, PortalBadge, RateLine } from './PositionBadges';

/** Card body for the pipeline board (the Board component renders the frame and handles drag). */
export function PositionCard({ position }: { position: PositionListItem }) {
  const { computed } = position;
  return (
    <div className="space-y-2">
      <div className="min-w-0">
        <div className="font-mono text-[11px] text-muted-foreground">
          {position.requestNo}
          {position.intermediary ? ` · ${position.intermediary.shortCode || position.intermediary.name}` : ''}
        </div>
        <div className="line-clamp-2 font-medium leading-snug">{position.role}</div>
      </div>
      <div className="flex flex-wrap items-center gap-1">
        <PortalBadge position={position} size="sm" showChecked={false} />
        <FlagBadges computed={computed} size="sm" />
        {position.stage === 'NEW' ? (
          <EnumBadge def={GoDecision} value={position.goDecision} size="sm" />
        ) : null}
      </div>
      <RateLine position={position} rates={position.rates} className="block text-xs" />
      <div className="flex flex-wrap items-center gap-x-3 gap-y-1 text-xs text-muted-foreground">
        <span className="inline-flex items-center gap-1">
          <Users className="h-3 w-3" aria-hidden="true" />
          {computed.submissionsCount}
          <span className="sr-only"> submissions</span>
          {computed.submittedCount > 0 ? ` (${computed.submittedCount} submitted)` : ''}
        </span>
        {position.startDate ? (
          <span className="inline-flex items-center gap-1">
            <CalendarDays className="h-3 w-3" aria-hidden="true" />
            <time dateTime={position.startDate}>{formatDate(position.startDate)}</time>
          </span>
        ) : null}
      </div>
    </div>
  );
}
